export const tokenProps = {
  audience: "https://tools.sw.siemens.com/tools-manager/api/",
  scope: 'openid profile email'
};

export const providerProps = {
  audience: "https://tools.sw.siemens.com/tools-manager/api/",
  clientId: "GISzR47rQhvWEhhCJtaILRPnloUFo7WA",
  domain: "diswlogin.siemens.com",
  redirectUri: `${window.location.origin}/auth/mentor`,
  scope: 'openid profile email'
};



// WEBPACK FOOTER //
// ./app/utils/auth0.js